angular.module('app.directives').directive('vpAreaSymbol', ($rootScope) => ({
    restrict: 'E',
    scope: {},

    bindToController: {
        model: '<',
    },

    controllerAs: 'vm',

    controller() {
        const vm = this;

        vm.icon = '';
        vm.iconClass = '';
        vm.title = '';

        // moved from somewhere
        if (vm.model.previous_area_id > 0 && vm.model.previous_area_id != $rootScope.$session.area.id && vm.model.area_id == $rootScope.$session.area.id) {
            vm.icon = 'call_missed';
            vm.iconClass = 'material-icons md-success-color';
            vm.title = `${vm.model.previous_area.symbol} ${vm.model.previous_area.name}`;

            // moved to somewhere
        } else if (vm.model.previous_area_id == $rootScope.$session.area.id) {
            vm.icon = 'call_missed_outgoing';
            vm.iconClass = 'material-icons md-danger-color';
            vm.title = `${vm.model.area.symbol} ${vm.model.area.name}`;
        }
    },

    template:
        '{{ :: vm.model.area_symbol }} &nbsp; <span ng-class=":: vm.iconClass" data-uk-tooltip="{cls:\'uk-tooltip-small\',pos:\'bottom\'}" title="{{ :: vm.title }}">{{ :: vm.icon }}</span>',
}));
